import React from 'react';
import NumberFormat from 'react-number-format';

const Money = props => {
  return <NumberFormat
    thousandSeparator={'.'}
    decimalSeparator={','}
    decimalScale={2}
    fixedDecimalScale={true}
    displayType={'text'}
    prefix={props.prefix}
    value={props.price} />;
}

export const formatCurrency = (value, thousands = true) => {
  if (value) {
    if (typeof value === 'number') {
      value = value.toFixed(2).toString();
    }
    const signal = value.indexOf('-') !== -1 ? '-' : ''; 
    let newValue = value.replace(/\D/g, "");
    if (newValue === "") {
      newValue = "0";
    }
    if (newValue.length <= 4) {
      newValue = parseInt(newValue).toString();
    }
    newValue = newValue.padStart(3, "0");
    let decimals = newValue.substr(-2);
    let units = newValue.substr(0, newValue.length - 2);

    let unitsArr = [...units].reverse();
    let newUnitsArr = [];
    for (let x = 0; x < unitsArr.length; x++) {
      if (x > 0 && x % 3 === 0) {
        if (thousands) {
          newUnitsArr.push(".");
        }
      }
      newUnitsArr.push(unitsArr[x]);
    }

    return signal + newUnitsArr.reverse().join("") + "," + decimals;
  } else {
    return '0,00';
  }
}

export const currencyToFloat = (value) => {
  if (value) {
    value = value.toString();
    const signal = value.indexOf('-') !== -1 ? '-' : ''; 
    let newValue = value.replace(/\D/g, "");
    if (newValue === "") {
      newValue = "0";
    }
    if (newValue.length <= 4) {
      newValue = parseInt(newValue).toString();
    }
    newValue = newValue.padStart(3, "0");
    let decimals = newValue.substr(-2);
    let units = newValue.substr(0, newValue.length - 2);
    return parseFloat(`${signal}${units}.${decimals}`);
  }
}

export default Money;